export const gender = {
    1: 'male',
    2: 'female',
    3: 'other',
};
